import React, { useEffect, useState, useRef } from 'react';

function ScrollReveal({ 
  children,
  direction = 'left', 
  size = 120,
  offset = 0,
  className = ''
}) {
  const [isVisible, setIsVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 768);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  useEffect(() => {
    if (isMobile) {
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
          }
        },
        { threshold: 0.3 }
      );

      if (ref.current) {
        observer.observe(ref.current);
      }

      return () => {
        if (ref.current) {
          observer.unobserve(ref.current);
        }
      };
    } else {
      const getGhostTriggerPercent = () => {
        const ghostNum = className.match(/ghost-(\d+)/);
        if (!ghostNum) return 10;
        const triggers = { 1: 5, 2: 20, 3: 35, 4: 50, 5: 65, 6: 80 };
        return triggers[ghostNum[1]] || 10;
      };

      const triggerPercent = getGhostTriggerPercent();

      const handleScroll = () => {
        const scrollPercent = (window.scrollY / (document.documentElement.scrollHeight - window.innerHeight)) * 100;
        if (scrollPercent >= triggerPercent) {
          setIsVisible(true);
        }
      };

      window.addEventListener('scroll', handleScroll, { passive: true });
      handleScroll();

      return () => window.removeEventListener('scroll', handleScroll);
    }
  }, [isMobile]);

  const style = {
    '--ghost-size': `${size}px`,
    '--ghost-offset': `${offset}px`,
  };

  return (
    <div 
      ref={ref}
      className={`scroll-reveal scroll-reveal-${direction} ${isVisible ? 'scroll-reveal-visible' : ''} ${className}`}
      style={style}
    >
      {children}
    </div>
  );
}

export default ScrollReveal;
